
<mt-button
    v-if="activePlan != 'pro'"
    :variant="statisticsVariant"
    class="dvsn-form-builder-in-app-current-month-button"
    size="default"
    :isLoading="isLoading"
    @click="openStatisticsModal()"
>
    {{ statisticsButton }}
</mt-button>

<mt-button
    :variant="inAppVariant"
    size="default"
    @click="openInAppPurchaseModal()"
>
    {{ $t('dvsn-form-builder.in-app.button.buy-in-app-plan') }}
</mt-button>

<sw-modal
    v-if="showInAppModal"
    class="dvsn-form-builder-in-app-abos-modal"
    :title="$t('dvsn-form-builder.in-app.abos-modal.title')"
    @modal-close="closeInAppPurchaseModal()"
>
    <sw-container columns="1fr 1fr 1fr 1fr" style="column-gap: 18px;">
        <div
            v-for="(plan, key) in plans"
            :key="key"
            class="abo-container"
            :class="[`is--${key}`, { 'is--selected': activePlan === key }]"
        >
            <span class="title">{{ plan.name }}</span>

            <mt-icon
                :name="plan.icon"
                size="60px"
            />

            <span class="price">
                <span class="starting-from" v-if="key != 'none'">{{ $t('dvsn-form-builder.in-app.abos-modal.abo.starting-from') }}</span>
                {{ plan.price }}
                <span class="month">/ {{ $t('dvsn-form-builder.in-app.abos-modal.abo.price-month') }}</span>
            </span>

            <span v-if="plan.value != null" class="value">
                {{ $t('dvsn-form-builder.in-app.abos-modal.abo.up-to') }}
                <strong>{{ plan.value }}</strong>
            </span>

            <span v-else class="value">
                <strong>{{ $t('dvsn-form-builder.in-app.abos-modal.abo.unlimited') }}</strong>
            </span>

            <span class="legend">{{ $t('dvsn-form-builder.in-app.abos-modal.abo.legend') }}</span>

            <mt-button
                :disabled="buttonIsDisabled(plan)"
                variant="secondary"
                size="default"
                @click="openInAppPurchase(key)"
            >
                <template v-if="key == 'none'">
                    Inkludiert
                </template>

                <template v-else>
                    {{ activePlan === key ? $t('dvsn-form-builder.in-app.abos-modal.abo.button.is-active') : $t('dvsn-form-builder.in-app.abos-modal.abo.button.open-in-app') }}
                </template>
            </mt-button>
        </div>
    </sw-container>

    <div class="tax-info">
        {{ $t('dvsn-form-builder.in-app.abos-modal.abo.tax-info') }}
    </div>

    <template #modal-footer>
        <mt-button
            variant="secondary"
            size="small"
            @click="closeInAppPurchaseModal()"
        >
            {{ $t('global.default.close') }}
        </mt-button>
    </template>
</sw-modal>

<sw-modal
    v-if="showStatisticsModal"
    class="dvsn-form-builder-in-app-statistics-modal"
    :title="$t('dvsn-form-builder.in-app.statistics-modal.title')"
    @modal-close="closeStatisticsModal()"
>
    <mt-banner
        variant="info"
    >
        {{ $t('dvsn-form-builder.in-app.statistics-modal.banner') }}
    </mt-banner>

    <template #modal-footer>
        <mt-button
            variant="secondary"
            size="small"
            @click="closeStatisticsModal()"
        >
            {{ $t('global.default.close') }}
        </mt-button>
    </template>
</sw-modal>
